import React from 'react';

import './_errorPageStyles.scss';

const NotPermittedPage: React.FC = () => {
  return (
    <div className={`error-page`}>
      <h1 className="plum">403</h1>
      <div className="error-page__container">
        <p>User has no permissions to see this page.</p>
      </div>
    </div>
  );
};

export default NotPermittedPage;
